import { Button, Card, message, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Title } from '../../../../components';
import StepperSolicitud from '../../../../components/StepperSolicitud';
import { useInspeccionContext } from '../../../../context/inspeccion-context';
import Fotografias from './Fotografias';
import FotografiasGrid from './FotografiasGrid';
import LandingPage from './Landing';
import Success from './Success';

function SolicitanteSteps(props) {
  const { hasImagenes, getInspeccion } = useInspeccionContext();
  const [step, setStep] = React.useState(0);
  const [start, setStart] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [reaundar, setReanudar] = React.useState(false);
  const [inspeccion, setInspeccion] = React.useState();
  const location = useLocation();

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch = async () => {
    setLoading(true);
    const fullPath = location.pathname;
    const inspeccionResult = await getInspeccion(
      props.props.match.params.token,
      fullPath
    );
    setInspeccion(inspeccionResult);
    if (inspeccionResult.estado === 'INICIADA') {
      setStep(stepPages.length - 2);
    } else if (inspeccionResult.estado !== 'PENDIENTE') {
      setStep(stepPages.length);
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const continueStep = async () => {
    setReanudar(true);
    setStep(1);
  };

  const next = async () => {
    setStep(step + 1);
  };

  const back = () => {
    setStep(step - 1);
  };

  const onFotosBack = async () => {
    setStart(false);
    setStep(step - 1);
  };

  const steps = [
    {
      title: 'Paso 1',
      description: (
        <span>
          Instrucciones de <strong>Inspección</strong>
        </span>
      )
    },
    {
      title: 'Paso 2',
      description: <span>Subí las fotos del vehículo</span>
    },
    {
      title: 'Paso 3',
      description: (
        <span>
          Confirmar <strong>fotografías</strong>
        </span>
      )
    }
  ];

  const stepPages = [
    <LandingPage title={steps[0].description} />,
    <Fotografias
      title={steps[1].description}
      next={next}
      back={back}
      start={start}
      continue={reaundar}
    />,
    <FotografiasGrid
      title={steps[2].description}
      next={next}
      back={onFotosBack}
      continueStep={continueStep}
    />
  ];

  const lastStepIndex = stepPages.length - 1;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onStepSubmit = React.useCallback(() => {
    if (step === 1 && !hasImagenes) {
      message.error('Debe subir las fotos del vehículo');
    } else {
      setStep(() => Math.min(step + 1, lastStepIndex));
      setStart(true);
    }
  });

  const getButtons = () => {
    if (step === 0) {
      return (
        <Button type="primary" onClick={onStepSubmit}>
          Siguiente
        </Button>
      );
    }
    return null;
  };

  return (
    <Card>
      <Title>Inspección del vehículo</Title>
      <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
        {!loading && (
          <>
            {step === stepPages.length ? (
              <Success inspeccion={inspeccion} />
            ) : (
              <div>
                <StepperSolicitud current={step} steps={steps.slice(0, 6)} />
                <div>
                  {stepPages[step]}
                  <br />
                  <div>{getButtons()}</div>
                </div>
              </div>
            )}
          </>
        )}
      </Spin>
    </Card>
  );
}

export default SolicitanteSteps;
